<div #pdfViewer>
  <pdf-viewer
    [src]="pdfSrc"
    [render-text]="true"
    [show-all]="true"
    style="display: block"
  ></pdf-viewer>
</div>
